// @flow
import * as React from 'react';
import { RequiredActionsList, useNotifications } from '../../../../../features';
import { useEffect, useState } from 'react';
import { RequiredActionOutput } from '@coverright/data-access/types/enrollment';

export const RequiredActions = () => {
  const serverActions = useNotifications();
  const [requiredActions, setRequiredActions] = useState<RequiredActionOutput[]>([]);

  useEffect(() => {
    setTimeout(() => setRequiredActions(serverActions), 500)
  }, [serverActions]);

  const handleResolved = (id: string) => {
    setRequiredActions(prev => prev.filter(n => n.id !== id));
  };

  return (
    <RequiredActionsList actions={requiredActions} onResolved={handleResolved} />
  );
};
